import React  from 'react'
import DropDown from '../dropdown';
import { GetNationalities } from '../../../api/services/shared';

const NationalitiesDropDown = ({...props}) => {
    
    return <DropDown search api={GetNationalities} textField="Name" valueField="Id" {...props}/>
}

export default NationalitiesDropDown